/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Demands_Match_FilterInputs */

const cs_demands_match_filter = /** @type {(inputs: Demands_Match_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shody`)
};

const en_demands_match_filter = /** @type {(inputs: Demands_Match_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matches`)
};

/**
* | output |
* | --- |
* | "Matches" |
*
* @param {Demands_Match_FilterInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const demands_match_filter = /** @type {((inputs?: Demands_Match_FilterInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Demands_Match_FilterInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_demands_match_filter(inputs)
	return cs_demands_match_filter(inputs)
});